import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MdKeyboardBackspace } from "react-icons/md";
import { LuBox } from "react-icons/lu";
import StarRating from "../../comman/startRating";
import { ReturnModal } from "../../../modal/returnRequest";
import { CancelModal } from "../../../modal/cancleModal";
import { useState,useEffect} from "react";
import { toast } from "react-toastify";
import axios from "axios";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";
import formatPaymentMethod from "../../comman/formatePaymentMethod";

const Base_Url = process.env.REACT_APP_BASE_URL;

function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}
export default function SectionDetail()
{
    const {id}=useParams();
    const [orderData, setOrderData] = useState(null);
    const navigate=useNavigate();
    const location = useLocation();
    const activeStep = location.state?.activeStep || 1;

    useEffect(() => {
    const fetchOrderDetails = async () => {
      if (!id) return;

      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${Base_Url}/api/productOrder/getOrderDetails/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (res.data.success) {
          setOrderData(res.data.data);
        } else {
          toast.error(res.data.message || "Failed to fetch order details");
        }
      } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Failed to fetch order details");
      }
    };

    fetchOrderDetails();
    }, [id]);

const [showReturnModal, setShowReturnModal] = useState(false);
const [showCancelModal, setShowCancelModal] = useState(false);
const [selectedProductItemId,setSelectedProductItemId] = useState(null);
const [selectedOrderItemId,setSelectedOrderItemId] = useState(null);

const [ratings, setRatings] = useState({});
const [reviews, setReviews] = useState({});


const handleSubmitReview =async (productId,orderId) => {
  
  const rating = ratings[productId] || 0;
  const review = reviews[productId] || "";
    try {
        const token = localStorage.getItem("token");
        const res = await axios.post(
          `${Base_Url}/api/productReview/addReview/${orderId}/${productId}`,
          {rating, review},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (res.data.success) {
          toast.success(res.data.message || "Review added successfully..");
        }
        setRatings(prev => ({ ...prev, [productId]: 0 }));
        setReviews(prev => ({ ...prev, [productId]: "" }));
    } catch (err) 
    {
        console.error(err);
        if (err.response?.status === 400) {
            toast.info(err.response.data?.message);
        } else 
        {
        toast.error(err.response?.data?.message || "Failed to add review for this product");
        }
    }
    

};

if (!orderData) return <p className="text-gray-800 text-center">Loading order details...</p>;

    return(
<section className="py-5 md:py-8 px-4 md:px-8 xl:px-10">
    <button 
        className="flex flex-row space-x-2 items-center mb-5" 
        onClick={() => navigate("/orderpage", { state: { activeStep } })}
    >
        <MdKeyboardBackspace className="text-base md:text-lg xl:text-xl" />
        <h2 className="text-base md:text-lg xl:text-xl font-bold">Order detail</h2>
    </button>

    <div className="flex flex-col md:flex-row justify-between gap-5 w-full mb-5">
      <div className="flex flex-row justify-between w-full lg:w-1/2 bg-slate-100 p-2 py-4 md:p-4 rounded-md">
        <div className="flex flex-row space-x-2 items-center">
            <div className="">
                 <LuBox className="text-xl md:text-2xl xl:text-3xl"/>
            </div>

            <div className="flex flex-col justify-between">
                <p className="text-xs md:text-sm xl:text-base font-medium">
                    Status: {orderData.status==="newRequest" ? 
                    "Ordered" : 
                    orderData.status
                    ? orderData.status
                    .replace(/([A-Z])/g, " $1") 
                    .replace(/^./, (str) => str.toUpperCase()) 
                    : ""}
                </p>
                <p className="text-[10px] md:text-xs xl:text-sm text-gray-500">
                    On {new Date(orderData.createdAt).toLocaleDateString("en-US", 
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })} at {new Date(orderData.createdAt).toLocaleTimeString("en-US", 
                    {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}
                </p>
            </div>
        </div>

        {!orderData.status==="cancelled" && (
        <div className="flex flex-col space-y-3">
            {orderData.status === "delivered" ? (
                <button className="bg-green-600 text-white p-1 md:px-3 md:py-1 rounded-md text-xs md:text-sm xl:text-base"
                onClick={()=>navigate(`/invoicepage/${orderData.orderId}`)}>
                    Payment Summary
                </button>
                ) : (
                <button className="bg-blue-600 text-white p-1 md:px-3 md:py-1 rounded-md text-xs md:text-sm      xl:text-base" 
                onClick={()=>navigate(`/ordertrack/${orderData.orderId}`)}>
                    Track Order
                </button>
            )}                      
        </div>
        )}
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7">
        {orderData.items.length < 1 ? (
            <p className="bg-slate-100 px-2 py-2 rounded-md text-xs md:text-sm lg:text-base font-medium w-fit">
                No items found in this order.
            </p>
        ) : (orderData.items.map((row,idx)=>(
        <div
            key={idx}
            className={`flex flex-col space-y-4 p-2 py-4 md:p-4 rounded-md 
            ${row.isCancelled ? "border border-red-500 bg-red-50" : "border border-transparent bg-slate-100"}`}
        >
        
          <div className="flex flex-row space-x-2 justify-between pb-3">
                <div className="w-1/4 flex justify-center items-center">
                    <img 
                        src={row.product?.images?.[0]} 
                        alt={row.product.productName || `Product ${idx + 1}`} 
                        className="w-24 h-20 md:w-24 md:h-24"
                    />
                </div>
                <div className="w-3/4 flex flex-col space-y-1">
                    <p className="text-xs md:text-sm xl:text-base font-medium">{row.product.productName} {row.product.category?.name} {row.product.model}</p>
                    <p className="text-xs md:text-sm xl:text-base">{row.product.description}</p>
                    <hr className="border border-gray-400"/>
                    <p className="text-xs md:text-sm xl:text-base">₹ {Math.round(row.product.discountedPrice)} (Incl. all taxes)</p>
                    <p className="text-xs md:text-sm xl:text-base">Qauantity : {row.quantity}</p>
                </div>
          </div>

          <div className="flex flex-row justify-end items-center">
            {((orderData.status === "delivered") && row.isReturned===false)&& (
                <button className="shadow bg-[#A63F40] text-white p-1  xl:px-3 xl:py-1  rounded-md text-xs md:text-sm xl:text-base"
                onClick={() => {
                        setShowReturnModal(true);
                        setSelectedOrderItemId(row.id);
                }}>
                    Return this item 
                </button>
            )}
            {row.isReturned===true &&(
                <span className="inline-block mt-2 text-blue-600 bg-white px-2 py-1 rounded-md text-xs md:text-sm font-medium w-fit">
                    This item has been returned
                </span>
            )}
            {((orderData.status === "newRequest" || orderData.status === "processing") && row.isCancelled===false ) && (
                <button className="text-blue-600 shadow bg-blue-100 p-1  xl:px-3 xl:py-1 rounded-md text-xs md:text-sm xl:text-base"
                onClick={() => 
                    {
                        setShowCancelModal(true);
                        setSelectedProductItemId(row.id);
                    }}>
                    Cancle Order
                </button>
            )}

            {row.isCancelled===true &&(
                <span className="inline-block mt-2 text-red-600 bg-white px-2 py-1 rounded-md text-xs md:text-sm font-medium w-fit">
                    This item has been cancelled
                </span>
            )}
          </div>         
          {row.product.canReview === true && (
          orderData.status === "delivered" && (
          <form
            className="flex flex-col space-y-3 border border-[#A63F40] bg-white rounded-md p-3 lg:p-5"
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmitReview(row.product.id,orderData.orderId); 
            }}
          > 

            <div className="flex flex-row space-x-2 items-center">
                <StarRating
                    initialRating={ratings[row.product.id] || 0}
                    onRate={(newRating) => setRatings(prev => ({ ...prev, [row.product.id]: newRating }))}
                />
            </div>

                <div className="flex flex-row space-x-3 items-center text-xs md:text-sm xl:text-base">
                    <div className="flex flex-row space-x-2 items-center flex-1">
                        <label>Review</label>
                        <input
                            type="text"
                            className="border border-gray-400 rounded p-1 focus:outline-none w-full"
                            value={reviews[row.product.id] || ""}
                            onChange={(e) =>
                                setReviews(prev => ({ ...prev, [row.product.id]: e.target.value }))
                            }
                            placeholder="Write your review..."
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-white shadow-md border border-[#A63F40] text-[#A63F40] px-3 py-1 rounded"
                    >
                        Submit
                    </button>
                </div>
          </form>
          ))}
          
        </div>
        ))
        )}      
    </div>

    <div className="flex flex-col md:flex-row gap-5 mt-6">
    <div className="border border-gray-300 shadow-md rounded p-4 md:p-6 w-full md:w-2/3">
        <p className="text-sm md:text-base xl:text-lg font-medium mb-3">Order Summary</p>
        <div className="flex flex-col md:flex-row gap-3 justify-between text-xs md:text-sm xl:text-base">
            <div className="grid grid-cols-2 gap-y-0">
                <p>Order Date :</p>
                <p>
                    {new Date(orderData.createdAt).toLocaleDateString("en-US", 
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })}
                </p>
                <p>Order Id :</p>
                <p>{orderData.orderId}</p>
                <p>Items :</p>
                <p>{orderData.items.length}</p>
                <p>Payment Mode :</p>
                <p>{formatPaymentMethod(orderData.paymentMethod)}</p>
            </div>

            <div className="grid grid-cols-2 gap-y-1 gap-x-4">
                <p>Subtotal :</p>
                <p>₹{formatNumber(orderData.subTotal)}</p>
                <p>Handling Charge :</p>
                <p>+ ₹{formatNumber(orderData.handlingCharges)}</p>
                <p>GST ({}%) :</p>
                <p>+ ₹{formatNumber(orderData.gstAmount)}</p>
                <p>Discount :</p>
                <p>- ₹{formatNumber(orderData.discountAmount)}</p>
                <hr className="border border-gray-300 col-span-2"/>
                <p className="font-semibold">Order Total:</p>
                <p className="font-semibold">₹{formatNumber(orderData.totalAmount)}</p>
            </div>            
        </div>
    </div>
    <div className="border border-gray-300 shadow-md rounded p-4 md:p-6 w-full md:w-1/3">
        <p className="text-sm md:text-base xl:text-lg font-medium mb-3">Order Ship to</p>
        <div className="flex flex-col text-xs md:text-sm xl:text-base">
            <p>{capitalizeFirstLetter(orderData.user.name)}</p>
            <p>{orderData.user.email}</p>
            <p>{orderData.user.mobileNumber}</p>
            <p>{capitalizeFirstLetter(orderData.address.buildingBlock)} {orderData.address.flatNo} {orderData.address.buildingName} 
              {orderData.address.streetName} {orderData.address.landmark} {orderData.address.city} {orderData.address.pincode}</p>
        </div>
    </div>
    </div>

    <ReturnModal 
        open={showReturnModal} 
        onClose={() => setShowReturnModal(false)} 
        orderId={orderData.orderId} 
        orderItemId={selectedOrderItemId}
    />
    
    <CancelModal 
        open={showCancelModal} 
        onClose={() => setShowCancelModal(false)} 
        orderId={orderData.orderId}
        orderItemId={selectedProductItemId}
    />
</section>
    );
}
